import { FILES_TYPES } from './files/constants';
import { getFileExtension } from './files/getFileExtension';
export function hasOthers(fileCollection) {
    return fileCollection.files.some((file) => FILES_TYPES[getFileExtension(file.name).toUpperCase()]);
}
//# sourceMappingURL=hasOthers.js.map